import React, { FC } from 'react'

interface NoDataFound{
   message?:string
}

export const NoDataFound:FC<NoDataFound> = ({message}) => {
  return (
    <div className='row'>
        <h2 className='text-center'>{message ? message : 'No Data Found'}</h2>
    </div>
  )
}


